import styled from '@emotion/styled';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const FormRow = styled('div')<{
  alignItems?: CSSProperties['alignItems'];
}>`
  display: flex;
  align-items: ${(p) => p.alignItems || 'center'};
  gap: ${(p) => p.theme.spacing()}px;
  margin-bottom: ${(p) => p.theme.spacing(2)}px;
`;

export const FormRowGroup = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  margin-bottom: ${(p) => p.theme.spacing(4)}px;
`;

export const FormSection = styled('div')<{
  alignItems?: CSSProperties['alignItems'];
}>`
  margin-block-end: ${(p) => p.theme.spacing(2)}px;
`;
